<template>
  <div class="modal-container" :class="{fullScreen}" @click.stop="">
    <div class="blure" @click.stop="$emit('close')" @touchstart.stop="" @touchend.stop=""></div>
    <div class="modal" :class="{ 'modal-style': styling }">
      <button v-if="showCloseBtn" class="close-btn" @click.stop="$emit('close')">✖</button>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    styling: {
      type: Boolean,
      default: true
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.modal-container {
  --clr-0: #000;
  --clr-1: #fff;
  position: fixed !important;
  z-index: 9999 !important;
  height: 100vh !important;
  width: 100vw !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  .blure {
    position: fixed !important;
    z-index: 9999 !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    // background-color: $blure-clr;
    background-color: rgba(0, 0, 0, 0.5) !important;
    backdrop-filter: blur(2px);
  }
  .modal {
    position: fixed;
    z-index: 10000;
    top: 50%;
    left: 50%;
    width: fit-content;
    // height: fit-content;
    max-width: 95vw;
    max-height: 95vh;
    transform: translate(-50%, -50%);
    [dir="rtl"] & {
      left: auto;
      right: 50%;
      transform: translate(50%, -50%);
    }

    overflow: hidden;

    @media (max-width: $small-screen-break) {
      min-width: 90vw;
    }

    .close-btn {
      width: em(16px);
      height: em(16px);
      position: absolute;
      top: em(15px);
      inset-inline-end: em(15px);
      inset-inline-start: auto;
      font-size: rem(16px);
      line-height: 1em;
      z-index: 35;
      background-color: transparent;
      // Use a toned-down grey that works on both light and dark backgrounds
      color: #666;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      cursor: pointer;
      transition: color 0.2s;
      font-weight: normal;
      &:hover {
        color: #333;
      }
    }

    &.modal-style {
      padding: em(35px);
      border-radius: em(5px);
      box-shadow: $light-shadow;
      // background-color: #fff;
      // color: black;
      background-color: var(--clr-1, #fff) !important;
      color: var(--clr-0, #000) !important;
      display: flex;
      flex-direction: column;
      .input, input, select {
        background-color: var(--clr-1) !important;
        color: var(--clr-0) !important;
      }
      // Ensure labels are visible - use heading color for better contrast
      // Add text-shadow for visibility on dark backgrounds
      label, .label {
        color: var(--clr-4, var(--clr-0)) !important;
        text-shadow: 0 0 em(2px) rgba(255, 255, 255, 0.3);
      }
      // Constrain dropdowns to modal boundaries - ensure they don't overflow modal
      .form-input {
        .drop-down {
          max-height: calc(250px) !important;
        }
      }
      // Make modal content (slot) scrollable - exclude close button
      > *:not(.close-btn) {
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
        min-height: 0;
        max-height: 100%;
      }
      // .btn {
      //   box-shadow: 0 0 em(10px) em(1px) rgba(0,0,0,0.2);
      // }
    }
  }

  &.fullScreen {
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
}
</style>